import React from "react";
import styled from "styled-components";
import img1 from "../../assets/homeAssets/img1.png";
import img2 from "../../assets/homeAssets/img2.png";
import img3 from "../../assets/homeAssets/img3.png";

const Banner2 = () => {
  return (
    <Container>
      <div className="rows">
        <div className="row">
          <h1>Discover</h1>
        </div>
        <div className="row">
          <img src={img1} alt="" />
        </div>
        <div className="row">
          <h1>Your</h1>
          <img className="img2" src={img2} alt="" />
        </div>
        <div className="row">
          <h1>Beauty.</h1>
          <h1>Defined.</h1>
        </div>
        <div className="row">
          <img src={img3} alt="" />
        </div>
        <div>
          <h1>Timeless</h1>
        </div>
      </div>
    </Container>
  );
};
const Container = styled.div`
  padding: 0;
  .rows {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .row {
      width: 90%;
      display: flex;
      justify-content: center;
      img {
        border-radius: 50px;
        width: 100%;
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            135deg,
            rgba(255, 255, 255, 0.1),
            rgba(255, 255, 255, 0)
          );
          z-index: 1;
        }

        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.6),
            transparent
          );
        }
      }

      .img2 {
        width: 30%;
        border-radius: 40%;
      }
    }
  }
`;

export default Banner2;
